import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { SimulationTabModel } from './models/simulation-tab.model';
import { Papa } from 'ngx-papaparse';
import { FileSaverService } from 'ngx-filesaver';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'phenology';

  public activeTabId: string;
  public simulations: Array<SimulationTabModel> = [];

  public csvContent: string;

  public tabCounter = 1;

  constructor(private FileSaverService: FileSaverService) {
    // DEMO
    // this.simulations = [{
    //   status: 0,
    //   id: '1',
    //   name: 'DEMO - Desha Arkansas',
    //   plantingDate: '2020-05-29',
    //   crop: 'soybean',
    //   maturity: '4.9',
    //   sowingDepth: 5,
    //   coordinates: {
    //     latitude: 33.82,
    //     longitude: -91.29
    //   },

    //   compareYear: 2018,
    //   dataMode: 'daily'
    // }];

    this.addNewTab(null);

  }

  ngOnInit(): void {
    this.activeTabId = this.simulations[0].id;
  }

  public addNewTab(e): void {
    if (e != null) {
      e.stopPropagation();
    }

    if (this.simulations.length < 5) {
      const uuid = getUniqueId(4);
      this.simulations.push({
        status: 0,
        progressLoad: 0,
        id: uuid,
        name: `Sim. Tab #${this.tabCounter++}`,

        plantingDate: null, //moment().format('YYYY-MM-DD'),
        crop: null,
        maturity: null,
        sowingDepth: 5,
        coordinates: { 
          latitude: 39.828345, // Central USA
          longitude: -98.579522 // Central USA
          //latitude:  33.137551, // Southeast
          //longitude: -85.297852  // Southeast
        },

        compareYear: 2020,
        dataMode: 'daily'
      });

      this.activeTabId = uuid;
    } else {
      console.log('Too many tabs. Max of 5 tabs allowed.');
    }
  }

  public removeTab(tabId: number | string): void {
    this.simulations = this.simulations.filter(s => s.id != tabId);

    if (this.simulations.length == 0) {
      this.addNewTab(null);
    }

    this.activeTabId = this.simulations[0].id;
  }

  public setTabName(name: string): string {
    return name == null ? `Sim. Tab #${this.tabCounter}` : name.length > 12 ? name.slice(0, 12) + '...' : name;
  }

  public onFileSelect(input: HTMLInputElement): void {

    const files = input.files;

    if (files && files.length) {

      // console.log("Filename: " + files[0].name);
      // console.log("Type: " + files[0].type);
      // console.log("Size: " + files[0].size + " bytes");

      const fileToRead = files[0];

      const fileReader = new FileReader();
      fileReader.onload = ((f) => {
        return (e) => {

          const textFromFileLoaded = e.target.result;
          this.csvContent = textFromFileLoaded;

          new Papa().parse(this.csvContent, {
            header: true,
            complete: (result) => {


              if (!['name', 'plantingDate', 'crop', 'maturity', 'latitude', 'longitude', 'compareYear', 'dataMode'].every(i => Object.keys(result.data[0]).includes(i))) {
                alert('File does not contain all required columns. Please verify CSV data and try again.');
                return false;
              }

              if (confirm("Existing tabs will be discarded. Do you want to continue?")) {
                this.simulations = [];

                let fileLength = result.data.length
                if (fileLength > 5) {
                  fileLength = 5;
                  alert('Only 5 tabs allowed. The first 5 rows will be imported.');
                }

                let uuid;

                for (let i = 0; i < fileLength; i++) {
                  uuid = getUniqueId(4);

                  const data = result.data[i];

                  this.simulations.push({
                    status: 0,
                    progressLoad: 0,
                    id: uuid,
                    name: data.name || `Sim. Tab #${this.tabCounter++}`,

                    plantingDate: moment(data.plantingDate, 'MM/DD/YYYY').isValid() ? moment(data.plantingDate, 'MM/DD/YYYY').format('YYYY-MM-DD') : null,
                    crop: data.crop || null,
                    maturity: data.maturity || null,
                    sowingDepth: 5,
                    coordinates: {
                      latitude: data.latitude,
                      longitude: data.longitude
                    },

                    compareYear: data.compareYear || 2020,
                    dataMode: data.dataMode || 'daily'
                  });

                }

                this.activeTabId = uuid;

              }
            }
          });

        };
      })(fileToRead);

      fileReader.readAsText(fileToRead, "UTF-8");
      input.value = "";
    }

  }

  public saveTabs(): void {

    const dataToSave = [];

    this.simulations.forEach(s => {
      dataToSave.push({
        name: s.name,
        plantingDate: moment(s.plantingDate, 'YYYY-MM-DD').format('MM/DD/YYYY'),
        crop: s.crop,
        maturity: s.maturity,
        latitude: s.coordinates.latitude,
        longitude: s.coordinates.longitude,
        compareYear: s.compareYear,
        dataMode: s.dataMode
      });
    });

    console.log('Unparsed: ', new Papa().unparse(dataToSave, { header: true }));

    let parsedResponse = new Papa().unparse(dataToSave, { header: true });
    let blob = new Blob([parsedResponse], { type: 'text/csv' });

    let fileName = prompt('File name', `phenology_simulations_${moment().format('MMDDYYYY')}`)
    this.FileSaverService.save(blob, `${fileName}.csv`);

  }
}


/**
 * generate groups of 4 random characters
 * @example getUniqueId(1) : 607f
 * @example getUniqueId(2) : 95ca-361a-f8a1-1e73
 */
export function getUniqueId(parts: number): string {
  const stringArr = [];
  for (let i = 0; i < parts; i++) {
    // tslint:disable-next-line:no-bitwise
    const S4 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    stringArr.push(S4);
  }
  return stringArr.join('-');
}
